import { Component, OnInit, ViewChild } from '@angular/core';
import { of } from 'rxjs';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
// tslint:disable-next-line: max-line-length
import { GridComponent, ToolbarService, ToolbarItems, SearchSettingsModel, FilterService, SortService, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { WizardService } from '../services/wizard.service';
import { FilterActivePhaseViewModel, SelectedJobs, ActivePhase, Employee } from '../models/wizard.model';
import { isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import { JobSchedulePhaseViewModel, JobSchedulePhaseWorkForceViewModel, JobScheduleViewModel } from '../models/JobScheduleViewModel';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../services/user.service';
import { ItemModel, MenuEventArgs } from '@syncfusion/ej2-angular-splitbuttons';
import { FilteringEventArgs } from '@syncfusion/ej2-dropdowns';
import { EmitType } from '@syncfusion/ej2-base';
import { Query } from '@syncfusion/ej2-data';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
  providers: [
    FilterService,
    SortService,
    ToolbarService,
    FilterActivePhaseViewModel,
    SelectedJobs,
    ActivePhase,
    JobSchedulePhaseViewModel,
    DatePipe,
  ],
})
export class WizardComponent implements OnInit {
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly ngWizardService: NgWizardService,
    private readonly wizardService: WizardService,
    private filterActivePhaseViewModel: FilterActivePhaseViewModel,
    public activePhase: ActivePhase,
    public selectedJobs: SelectedJobs,
    private jobSchedulePhaseViewModel: JobSchedulePhaseViewModel,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly spinner: NgxSpinnerService,
    private readonly userService: UserService,
    private readonly datePipe: DatePipe
  ) {
    this.activePhase = new ActivePhase();
    this.selectedJobs.ActivePhase = new Array<ActivePhase>();
    this.JobScheduleViewModel = new JobScheduleViewModel();
    this.JobScheduleViewModel.jobSchedulePhaseViewModelList =
      new Array<JobSchedulePhaseViewModel>();
    this.jobSchedulePhaseViewModel = new JobSchedulePhaseViewModel();
  }
  toggleButtonText!: string;
  showSelectedPhaseGrid!: boolean;
  gridSelectedPhase: any;
  employeeVm!: Employee[];
  activeStep!: number;
  isModified = false;
  currentUser: any;
  action: any;
  showaddedPhaseBtn!: boolean;
  SelectedItem: any;
  btnNext!: boolean;
  btnPrevious!: boolean;
  btnFinish!: boolean;
  selectedCompanyID!: number;
  SelectedJobID: any;
  public showAllEmployees!: boolean;
  submitted = false;
  employeeDataSource: any;
  hasEmployeeData!: false;
  selectedEmployeeData: any;
  JobScheduleViewModel: JobScheduleViewModel;
  model: any = {};
  jobForm!: FormGroup;
  JobSchedulePhaseWorkForceVM!: JobSchedulePhaseWorkForceViewModel;
  step1 = true;
  jobScheduleId: any;
  currentJobScheduleId: any;
  public allowEditForDate = false;
  pageSettings!: { pageSizes: boolean; pageSize: number };
  workForcePageSettings!: { pageSizes: boolean; pageSize: number };
  @ViewChild('grid') public grid!: GridComponent;
  @ViewChild('addEmployeeGrid') public addEmployeeGrid!: GridComponent;
  @ViewChild('selectedPhaseGrid') public selectedPhaseGrid!: GridComponent;
  public toolbar!: ToolbarItems[];
  public searchSettings!: SearchSettingsModel;
  public filterSettings!: { type: string };
  sortOptions!: { columns: { field: string; direction: string }[] };
  // tslint:disable-next-line: ban-types
  public filteringType: object[] = [{ Id: 'Menu', type: 'Menu' }];
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden,
  };

  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      showPreviousButton: false,
      showNextButton: false,
    },
  };

  isValidTypeBoolean = true;
  expProdValue: any;
  public month: number = new Date().getMonth();
  public fullYear: number = new Date().getFullYear();
  public minDate: Date = new Date();
  public maxDate: Date = new Date(this.fullYear, this.month, 27);
  public today: Date = new Date();

  public fields: object = { text: 'Country', value: 'Id' };
  public equipmentsfields: object = { text: 'Country', value: 'Id' };
  public departmentfields: object = { text: 'Description', value: 'DeptId' };
  public jobfields: object = {
    text: 'contractIdDescription',
    value: 'contractId',
  };
  public itemfields: object = { text: 'itemDescription', value: 'item' };
  public Employeefields: object = { text: 'Description', value: 'EmpId' };
  public Companyfields: object = { text: 'name', value: 'companyId' };
  // set the placeholder to the DropDownList input
  public text = 'Select a country';
  public gridData!: object[];
  public date!: Date;
  public selectedPhaseData: any;

  // tslint:disable-next-line: ban-types
  public fieldsmultiselect: object = { text: 'Game', value: 'Id' };
  // set the placeholder to MultiSelect input element
  public waterMark = 'Select Member';
  public projectManager = 'James';
  // set the type of mode for how to visualized the selected items in input element.
  public default = 'Default';
  public box = 'Box';
  public delimiter = 'Delimiter';

  gridDataSource: any;
  public jobData: any;
  public _jobData: any;
  public itemDataSource: any;
  public _itemDataSource: any;
  public CompanyDataSource: any;

  arrayOfEmployeeNames: string[] = [];
  arrayOfEmployeeFullNames: string[] = [];

  public items: ItemModel[] = [
    {
      text: 'Copy Job',
      iconCss: 'fa fa-copy',
    },
    {
      text: 'Delete Job',
      iconCss: 'fa fa-trash',
    },
  ];

  ngOnInit(): void {
    this.showAllEmployees = false;
    this.submitted = false;
    this.selectedJobs = new SelectedJobs();

    const setCurrentDate = localStorage.getItem(
      'SetSchedulerCurrentDate'
    ) as any;
    if (!isNOU(setCurrentDate)) {
      const startDate = this.datePipe.transform(
        setCurrentDate,
        'MM/dd/yyyy'
      ) as any;
      this.selectedJobs.startDate = startDate;
    } else {
      this.selectedJobs.startDate = new Date(
        this.today.setDate(this.today.getDate() + 1)
      );
    }

    this.gridData = this.gridData;
    this.pageSettings = { pageSizes: true, pageSize: 20 };
    this.workForcePageSettings = { pageSizes: true, pageSize: 1000 };
    this.toolbar = ['Search'];
    // this.searchSettings = { fields: ['Name', 'MFGGroupCode'] };
    this.filterSettings = { type: 'Menu' };
    this.jobForm = this.formBuilder.group({
      expProd: [''],
      phaseId: [''],
    });

    this.getAllCompanies();
    this.currentJobScheduleId = this.route.snapshot.params['Id'];
    this.GetShowAddedPhaseBtnDetail(this.currentJobScheduleId);
    this.toggleButtonText = 'Show Selected Phases';
    this.showSelectedPhaseGrid = false;

    if (!isNOU(this.currentJobScheduleId)) {
      this.toggleButtonText = 'Add New Phase';
      this.showSelectedPhaseGrid = true;
      this.gridSelectedPhase = null;
      this.spinner.show();

      // const jobScheduleData = localStorage.getItem('dataSource');
      const jobScheduleData = undefined as any;
      if (isNOU(jobScheduleData)) {
        this.GetJobScheduleDataByScheduleId(this.currentJobScheduleId);
      } else {
        const jobschedule = JSON.parse(jobScheduleData) as JobScheduleViewModel;
        if (!isNOU(jobschedule)) {
          this.GetJobScheduleDataFromLocalStorage(jobschedule);
        } else {
          this.router.navigate(['/Wizard']);
        }
      }
    }

    this.GetCurrentUser();
  }

  GetShowAddedPhaseBtnDetail(currentJobScheduleId: Object): void {
    this.showaddedPhaseBtn = false;
    if (!isNOU(currentJobScheduleId)) {
      this.showaddedPhaseBtn = true;
    }
  }

  getAllJobs(): any {
    return this.wizardService.GetAllJobs().subscribe(
      (data: { body: any }) => {
        this.jobData = data.body;
        this._jobData = data.body;
      },
      () => {
        // console.log('Error: ', error);
      }
    );
  }

  ShowAllEmployees(): void {
    if (!this.showAllEmployees) {
      for (const iterator of this.selectedJobs.ActivePhase) {
        iterator.workForce = iterator.allWorkForce;
      }
    } else {
      for (const iterator of this.selectedJobs.ActivePhase) {
        iterator.workForce = iterator.currentCompanyWorkForce;
      }
    }
  }

  // tslint:disable-next-line: typedef
  showPreviousStep(action: any) {
    this.GetShowAddedPhaseBtnDetail(this.currentJobScheduleId);
    this.toggleButtonText = 'Add New Phase';
    this.action = action;
    this.InsertStepTwo();
  }

  // tslint:disable-next-line: typedef
  showNextStep(action: any) {
    this.action = action;
    if (this.step1) {
      if (isNOU(this.JobScheduleViewModel.jobId)) {
        this.submitted = true;
        return;
      }
      if (isNOU(this.selectedJobs.startDate || '')) {
        this.submitted = true;
      } else if (
        this.selectedJobs.ActivePhase.filter(
          (a: { isDeleted: any }) => !a.isDeleted
        ).length <= 0 &&
        (isNOU(this.JobScheduleViewModel) ||
          this.JobScheduleViewModel.jobSchedulePhaseViewModelList.length ===
            0 ||
          this.JobScheduleViewModel.jobSchedulePhaseViewModelList.filter(
            (i) => !i.isDeleted
          ).length <= 0)
      ) {
        Swal.fire('alert', 'Select any one phase from the table', 'warning');
      } else {
        this.spinner.show();
        if (!isNOU(this.currentJobScheduleId) && this.isModified) {
          this.InsertOrUpdateStepOne();
        } else {
          this.BindDataForInsertAndUpdate();
        }
      }
      // tslint:disable-next-line: triple-equals
    } else if (!this.step1 && this.action == 'SaveClose') {
      this.InsertStepTwo();
    } else {
      this.ngWizardService.next();
    }
  }
  InsertOrUpdateStepOne(): any {
    return this.wizardService
      .InsertOrUpdateStep1JobScheduleData(this.JobScheduleViewModel)
      .subscribe(
        (responsedata: { body: any }) => {
          if (responsedata.body != null) {
            this.jobScheduleId = responsedata.body as any;
            this.currentJobScheduleId = this.jobScheduleId;
            this.GetJobScheduleDataByScheduleId(this.jobScheduleId);
            // this.router.navigate([`Wizard/${this.jobScheduleId}`]);
            window.history.replaceState(
              null,
              '',
              '/Wizard/' + this.jobScheduleId
            );
            this.currentJobScheduleId = this.jobScheduleId;
            if (this.action === 'Next') {
              this.ngWizardService.next();
            } else if (this.action === 'SaveClose') {
              this.router.navigate(['/Scheduler']);
            }
          }
        },
        (error: any) => {
          if (error.status === 409) {
            alert(
              'Job has already been scheduled for the selected date.  Please choose a different date or job.'
            );
          }
          // console.log('Error: ', error);
          this.spinner.hide();
        }
      );
  }

  GetAllEmployeesByCompanyId(companyID: any, jobScheduleId: any): any {
    return this.wizardService
      .GetAllEmployeesByCompanyId(companyID, jobScheduleId)
      .subscribe(
        (responsesData: { body: Employee[] }) => {
          this.employeeVm = responsesData.body;
        },
        () => {
          // console.log('Error: ', error);
        }
      );
  }

  // tslint:disable-next-line: typedef
  resetWizard() {
    this.ngWizardService.reset();
  }

  // tslint:disable-next-line: typedef
  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  // tslint:disable-next-line: typedef
  stepChanged(args: StepChangedArgs) {
    this.activeStep = args.step.index;
    if (args.step.index === 0) {
      this.btnPrevious = false;
      this.btnNext = true;
      this.btnFinish = false;
      this.step1 = true;
    } else if (args.step.index === 1) {
      this.btnPrevious = true;
      this.btnNext = true;
      this.btnFinish = false;
      this.step1 = false;
    } else if (args.step.index === 2) {
      this.btnPrevious = true;
      this.btnNext = false;
      this.btnFinish = true;
      this.step1 = false;
      this.spinner.show();
      this.InsertStepTwo();
    }
  }
  GetJobScheduleDataByScheduleId(jobScheduleId: any): any {
    return this.wizardService
      .GetJobScheduleDataByJobScheduleId(jobScheduleId)
      .subscribe(
        (res: any) => {
          if (res.body != null) {
            if (!isNOU(this.currentJobScheduleId)) {
              this.getJobByCompanyID(res.body.companyId, res.body.startDate);

              this.getAllContractItemsByCompanyIdAndContractId(
                res.body.companyId,
                res.body.contractId
              );
              this.getAllActivePhases(res.body.companyId, res.body.contractId);
            }

            setTimeout(() => {
              this.JobScheduleViewModel = res.body;
              this.gridSelectedPhase =
                this.JobScheduleViewModel.jobSchedulePhaseViewModelList;
              this.getAllActivePhases(
                this.JobScheduleViewModel.companyId,
                this.JobScheduleViewModel.jobId
              );
              this.selectedJobs.ActivePhase = new Array<ActivePhase>();

              this.selectedJobs.startDate = this.JobScheduleViewModel.startDate;
              this.selectedCompanyID = this.JobScheduleViewModel.companyId;
              this.SelectedJobID = this.JobScheduleViewModel.contractId;
              this.selectedJobs.companyId = this.JobScheduleViewModel.companyId;
              for (const iterator of this.JobScheduleViewModel
                .jobSchedulePhaseViewModelList) {
                const tempActivePhase = new ActivePhase();
                tempActivePhase.description = iterator.phaseDescription;
                tempActivePhase.jobId = this.JobScheduleViewModel.contractId;
                tempActivePhase.estHours = null;
                tempActivePhase.estLaborProd = iterator.estLaborProd;
                tempActivePhase.estLaborUnits = null;
                tempActivePhase.isActive = !iterator.isDeleted;
                tempActivePhase.isDeleted = iterator.isDeleted;
                tempActivePhase.item = null;
                tempActivePhase.phaseGroupId = null;
                tempActivePhase.phaseId = iterator.phaseId;
                tempActivePhase.employees = iterator.employees;
                tempActivePhase.employeesFullName = iterator.employeesFullName;
                tempActivePhase.um = null;
                tempActivePhase.expProd = iterator.expProd;
                tempActivePhase.isAdded = true;
                tempActivePhase.workForce = new Array<Employee>();
                if (this.showAllEmployees) {
                  tempActivePhase.workForce = iterator.employeeViewModelList;
                } else {
                  tempActivePhase.workForce =
                    iterator.currentCompanyEmployeeViewModelList;
                }
                tempActivePhase.allWorkForce = new Array<Employee>();
                tempActivePhase.allWorkForce = iterator.employeeViewModelList;
                tempActivePhase.currentCompanyWorkForce = new Array<Employee>();
                tempActivePhase.currentCompanyWorkForce =
                  iterator.currentCompanyEmployeeViewModelList;

                this.selectedJobs.ActivePhase.push(tempActivePhase);
              }
              this.spinner.hide();
            }, 2000);
          } else {
            // console.log(res);
          }
        },
        () => {
          // console.log('Error: ', error);
        }
      );
  }

  GetJobScheduleDataFromLocalStorage(
    jobscheduleData: JobScheduleViewModel
  ): any {
    if (!isNOU(this.currentJobScheduleId)) {
      this.getJobByCompanyID(
        jobscheduleData.companyId,
        jobscheduleData.startDate
      );
      this.getAllContractItemsByCompanyIdAndContractId(
        jobscheduleData.companyId,
        jobscheduleData.contractId
      );
      this.getAllActivePhases(
        jobscheduleData.companyId,
        jobscheduleData.contractId
      );
    }

    setTimeout(() => {
      this.JobScheduleViewModel = jobscheduleData;
      localStorage.removeItem('dataSource');
      this.gridSelectedPhase =
        this.JobScheduleViewModel.jobSchedulePhaseViewModelList;
      this.getAllActivePhases(
        this.JobScheduleViewModel.companyId,
        this.JobScheduleViewModel.jobId
      );
      this.selectedJobs.ActivePhase = new Array<ActivePhase>();

      // this.selectedJobs.startDate = this.JobScheduleViewModel.startDate;
      this.selectedCompanyID = this.JobScheduleViewModel.companyId;
      this.SelectedJobID = this.JobScheduleViewModel.contractId;
      this.selectedJobs.companyId = this.JobScheduleViewModel.companyId;
      for (const iterator of this.JobScheduleViewModel
        .jobSchedulePhaseViewModelList) {
        const tempActivePhase = new ActivePhase();
        tempActivePhase.description = iterator.phaseDescription;
        tempActivePhase.jobId = this.JobScheduleViewModel.contractId;
        tempActivePhase.estHours = null;
        tempActivePhase.estLaborProd = iterator.estLaborProd;
        tempActivePhase.estLaborUnits = null;
        tempActivePhase.isActive = !iterator.isDeleted;
        tempActivePhase.isDeleted = iterator.isDeleted;
        tempActivePhase.item = null;
        tempActivePhase.phaseGroupId = null;
        tempActivePhase.phaseId = iterator.phaseId;
        tempActivePhase.employees = iterator.employees;
        tempActivePhase.employeesFullName = iterator.employeesFullName;
        tempActivePhase.um = null;
        tempActivePhase.expProd = iterator.expProd;
        tempActivePhase.isAdded = true;
        tempActivePhase.workForce = new Array<Employee>();
        tempActivePhase.workForce = iterator.employeeViewModelList;

        this.selectedJobs.ActivePhase.push(tempActivePhase);
      }
      this.spinner.hide();
    }, 2000);
  }

  InsertStepTwo(): any {
    return this.wizardService
      .InsertOrUpdateStep2JobScheduleData(this.JobScheduleViewModel)
      .subscribe(
        (responsedata: { body: any }) => {
          if (responsedata.body != null) {
            this.GetJobScheduleDataByScheduleId(this.jobScheduleId);
            if (this.action === 'Next') {
              this.ngWizardService.next();
            } else if (this.action === 'SaveClose') {
              this.router.navigate(['/Scheduler']);
            } else if (this.action === 'Previous') {
              this.ngWizardService.previous();
              this.showSelectedPhaseGrid = true;
            }
          }
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
          // console.log('Error: ', error);
        }
      );
  }
  BindDataForInsertAndUpdate(): any {
    this.JobScheduleViewModel.jobScheduleId = '';
    if (!isNOU(this.route.snapshot.params['Id'])) {
      this.JobScheduleViewModel.jobScheduleId =
        this.route.snapshot.params['Id'];
    } else if (!isNOU(this.jobScheduleId)) {
      this.JobScheduleViewModel.jobScheduleId = this.jobScheduleId;
    }
    this.JobScheduleViewModel.companyId = this.selectedCompanyID;
    this.JobScheduleViewModel.contractId = this.SelectedJobID;
    this.JobScheduleViewModel.jobId = this.SelectedJobID;
    this.JobScheduleViewModel.startDate = this.datePipe.transform(
      this.selectedJobs.startDate,
      'MM/dd/yyyy'
    ) as any;
    this.JobScheduleViewModel.jobScheduleStatusId = '';

    if (this.selectedJobs.ActivePhase && this.selectedJobs.ActivePhase.length) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.selectedJobs.ActivePhase.length; i++) {
        const item =
          this.JobScheduleViewModel.jobSchedulePhaseViewModelList.find((x) => {
            return (
              this.selectedJobs.ActivePhase &&
              x.phaseId === this.selectedJobs.ActivePhase[i].phaseId
            );
          });
        if (item == null) {
          this.jobSchedulePhaseViewModel = new JobSchedulePhaseViewModel();
          this.jobSchedulePhaseViewModel.phaseId =
            this.selectedJobs.ActivePhase[i].phaseId;
          this.jobSchedulePhaseViewModel.expProd =
            this.selectedJobs.ActivePhase[i].expProd;

          this.JobScheduleViewModel.jobSchedulePhaseViewModelList.push(
            this.jobSchedulePhaseViewModel
          );
        } else if (
          this.JobScheduleViewModel.jobSchedulePhaseViewModelList.find(
            (x) =>
              this.selectedJobs &&
              this.selectedJobs?.ActivePhase[i] &&
              x.phaseId === this.selectedJobs?.ActivePhase[i]?.phaseId &&
              x.expProd !== this.selectedJobs?.ActivePhase[i].expProd
          ) != null
        ) {
          for (
            let j = 0;
            j < this.JobScheduleViewModel.jobSchedulePhaseViewModelList.length;
            j++
          ) {
            if (
              this.JobScheduleViewModel.jobSchedulePhaseViewModelList[j]
                .phaseId === this.selectedJobs.ActivePhase[i].phaseId
            ) {
              this.JobScheduleViewModel.jobSchedulePhaseViewModelList.splice(
                j,
                1
              );
              this.jobSchedulePhaseViewModel = new JobSchedulePhaseViewModel();
              this.jobSchedulePhaseViewModel.phaseId =
                this.selectedJobs.ActivePhase[i].phaseId;
              this.jobSchedulePhaseViewModel.expProd =
                this.selectedJobs.ActivePhase[i].expProd;
              this.jobSchedulePhaseViewModel.isModified = true;
              this.JobScheduleViewModel.jobSchedulePhaseViewModelList.push(
                this.jobSchedulePhaseViewModel
              );
            }
          }
        }
      }
    }
    this.InsertOrUpdateStepOne();
  }

  // tslint:disable-next-line: typedef
  isValidFunctionReturnsBoolean() {
    return true;
  }

  // tslint:disable-next-line: typedef
  isValidFunctionReturnsObservable() {
    return of(true);
  }
  getAllCompanies(): any {
    return this.wizardService.GetAllCompanies().subscribe(
      (responsesData: any) => {
        this.CompanyDataSource = responsesData.body;
      },
      () => {
        // console.log('Error: ', error);
      }
    );
  }

  onCompanyChange(args: any): void {
    this.jobData = [];
    this._jobData = [];
    this.itemDataSource = [];
    this._itemDataSource = [];
    this.gridDataSource = [];
    this.selectedJobs.ActivePhase = [];
    if (!isNOU(args)) {
      this.selectedCompanyID = args.itemData.companyId;
      const startDate = this.datePipe.transform(
        this.selectedJobs.startDate,
        'MM/dd/yyyy'
      ) as any;
      this.getJobByCompanyID(this.selectedCompanyID, startDate);
    }
  }

  onDateChange(args: any): void {
    const startDate = this.datePipe.transform(args.value, 'MM/dd/yyyy') as any;
    this.selectedJobs.startDate = startDate;
    this.JobScheduleViewModel.startDate = startDate;
    this.getJobByCompanyID(
      this.selectedCompanyID,
      this.datePipe.transform(args.value, 'MM/dd/yyyy')
    );
  }

  getJobByCompanyID(companyID: number, startDate: any): any {
    return this.wizardService
      .GetAllJobsByCompanyId(companyID, startDate)
      .subscribe(
        (data: { body: any }) => {
          this.jobData = data.body;
          this._jobData = data.body;
        },
        () => {
          // console.log('Error: ', error);
        }
      );
  }

  onJobChange(args: any): void {
    this.jobData = [...this._jobData];
    if (isNOU(this.selectedJobs.ActivePhase)) {
      this.selectedJobs.ActivePhase = [];
    }
    this.JobScheduleViewModel.jobDescription = args.itemData.description;
    if (!isNOU(args.itemData)) {
      this.SelectedJobID = args.itemData.contractId;
      this.getAllContractItemsByCompanyIdAndContractId(
        this.selectedCompanyID,
        this.SelectedJobID
      );
    }

    if (this.selectedJobs.ActivePhase.length >= 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover selected phase',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((result: any) => {
        if (result.value) {
          this.selectedJobs.ActivePhase = [];
          this.gridDataSource = [];
          this.itemDataSource = [];
          this._itemDataSource = [];
          this.gridSelectedPhase = [];
          this.getAllContractItemsByCompanyIdAndContractId(
            this.selectedCompanyID,
            this.SelectedJobID
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          if (
            this.JobScheduleViewModel !== null &&
            !isNOU(this.JobScheduleViewModel.jobId)
          ) {
            this.JobScheduleViewModel.jobId = args.previousItemData.contractId;
          }
          this.SelectedJobID = args.previousItemData.contractId;
        }
      });
    } else {
      // this.SelectedItem = "All";
      // this.onItemChange(this.SelectedItem);
      this.getAllContractItemsByCompanyIdAndContractId(
        this.selectedCompanyID,
        this.SelectedJobID
      );
    }
  }

  getAllContractItemsByCompanyIdAndContractId(
    companyId: any,
    contractId: any
  ): any {
    return this.wizardService
      .GetAllContractItemsByCompanyIdAndContractId(companyId, contractId)
      .subscribe(
        (data: any) => {
          this.itemDataSource = data.body;
          this._itemDataSource = data.body;
          this.SelectedItem = 'All';
          this.onItemChange(this.SelectedItem);
        },
        () => {
          // console.log('Error: ', error);
        }
      );
  }

  onItemChange(args: any): void {
    this.itemDataSource = [...this._itemDataSource];
    this.filterActivePhaseViewModel.CompanyId = this.selectedCompanyID;
    this.filterActivePhaseViewModel.ContractId = this.SelectedJobID;
    this.filterActivePhaseViewModel.Item = !isNOU(args.itemData)
      ? args.itemData.item.replace(/\s/g, '')
      : args;
    this.getAllActivePhasesByFilterCriteria(this.filterActivePhaseViewModel);
  }

  OnExpProdChange(args: {
    event: { currentTarget: Element | EventTarget };
  }): void {
    if (!isNOU(this.currentJobScheduleId)) {
      this.selectedPhaseData = this.selectedPhaseGrid.getRowInfo(
        args.event.currentTarget
      );
      const value = (
        this.selectedPhaseData.row.querySelector(
          '.e-textbox.e-input'
        ) as HTMLInputElement
      ).value;

      for (const item of this.JobScheduleViewModel
        .jobSchedulePhaseViewModelList) {
        if (
          !isNOU(value) &&
          this.selectedPhaseData.rowData.phaseId === item.phaseId
        ) {
          item.expProd = value;
          item.isModified = true;
          this.isModified = true;
        }
      }
    }
  }

  workForceDataBound(gridObj: any): void {
    gridObj.toolbarModule.toolbar.items[0].align = 'Left';
  }

  getAllActivePhasesByFilterCriteria(
    filterActivePhaseViewModel: FilterActivePhaseViewModel
  ): any {
    return this.wizardService
      .GetAllActivePhasesByFilterCriteria(filterActivePhaseViewModel)
      .subscribe(
        (data: any) => {
          this.gridDataSource = data.body;
          if (
            this.JobScheduleViewModel !== null &&
            this.JobScheduleViewModel.jobSchedulePhaseViewModelList !== null
          ) {
            for (const iterator of this.JobScheduleViewModel
              .jobSchedulePhaseViewModelList) {
              let obj = this.gridDataSource.find(
                (g: { phaseId: string; jobId: string }) =>
                  g.phaseId === iterator.phaseId &&
                  g.jobId === this.JobScheduleViewModel.contractId
              );
              if (!isNOU(obj)) {
                obj.isAddedToJobSchedule = !iterator.isDeleted;
              }
            }

            if (
              this.selectedJobs !== null &&
              !isNOU(this.selectedJobs.ActivePhase)
            ) {
              for (const iterator of this.selectedJobs.ActivePhase) {
                let obj = this.gridDataSource.find(
                  (g: { phaseId: string; jobId: string }) =>
                    g.phaseId === iterator.phaseId && g.jobId === iterator.jobId
                );
                if (!isNOU(obj)) {
                  obj.isAddedToJobSchedule = !iterator.isDeleted;
                }
              }
            }
          }
        },
        () => {
          // console.log('Error: ', error);
        }
      );
  }

  getAllActivePhases(companyId: number, jobId: string): any {
    this.filterActivePhaseViewModel = new FilterActivePhaseViewModel();
    this.filterActivePhaseViewModel.CompanyId = companyId;
    this.filterActivePhaseViewModel.ContractId = jobId;
    this.filterActivePhaseViewModel.JobScheduleId =
      this.currentJobScheduleId !== null ? this.currentJobScheduleId : null;
    this.getAllActivePhasesByFilterCriteria(this.filterActivePhaseViewModel);
  }

  PhaseAddToObject(args: any): void {
    const rowInfo = this.grid.getRowInfo(args.target);
    const value = (
      rowInfo?.row?.querySelector('.e-textbox.e-input') as HTMLInputElement
    ).value;

    this.selectedPhaseData = this.grid.getRowInfo(args.target);

    if (!isNOU(this.selectedPhaseData.rowData)) {
      this.selectedPhaseData.rowData.isAdded = true;
      const startDate = this.datePipe.transform(
        this.selectedJobs.startDate,
        'MM/dd/yyyy'
      ) as any;
      this.selectedPhaseData.rowData.startDate = startDate;
      this.selectedPhaseData.rowData.expProd = value;
      this.selectedJobs.ActivePhase.push(this.selectedPhaseData.rowData);
    }
    this.grid.refresh();
  }

  PhaseDeleteFromObject(args: any): void {
    this.selectedPhaseData = this.grid.getRowInfo(args.target);
    for (let i = 0; i < this.selectedJobs.ActivePhase.length; i++) {
      const obj = this.selectedJobs.ActivePhase[i];

      if (
        this.selectedPhaseData.rowData.phaseId.replace(/\s/g, '').trim() ===
        obj.phaseId.replace(/\s/g, '').trim()
      ) {
        this.selectedJobs.ActivePhase[i].isAdded = false;
        this.selectedPhaseData.isAdded = false;
        this.selectedPhaseData.isDeleted = true;
        this.selectedJobs.ActivePhase.splice(i, 1);
      }
    }
    this.grid.refresh();
  }

  PhaseDeleteSelectedPhase(args: any): void {
    this.selectedPhaseData = this.selectedPhaseGrid.getRowInfo(args.target);
    for (
      let i = 0;
      i < this.JobScheduleViewModel.jobSchedulePhaseViewModelList.length;
      i++
    ) {
      const obj = this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i];

      if (
        this.selectedPhaseData.rowData.phaseId.replace(/\s/g, '').trim() ===
        obj.phaseId.replace(/\s/g, '').trim()
      ) {
        this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i].isDeleted =
          true;
        this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i].isModified =
          true;
      }

      const activephaseList =
        this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i];
      if (
        this.selectedPhaseData.rowData.phaseId.replace(/\s/g, '').trim() ===
        activephaseList.phaseId.replace(/\s/g, '').trim()
      ) {
        this.selectedJobs.ActivePhase[i].isDeleted = true;
        // this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i].isModified = true;
      }
    }

    this.gridSelectedPhase =
      // tslint:disable-next-line: only-arrow-functions typedef
      this.JobScheduleViewModel.jobSchedulePhaseViewModelList.filter(function (
        jobSchedulePhaseViewModel
      ) {
        return jobSchedulePhaseViewModel.isDeleted === false;
      });

    this.selectedPhaseGrid.refresh();
  }

  EmployeeAdded(): boolean {
    return true;
  }

  SaveAsIncomplete(args: any): void {
    this.action = args;

    if (this.step1) {
      this.BindDataForInsertAndUpdate();
    } else {
      this.spinner.show();
      this.InsertStepTwo();
    }
    // return this.wizardService
    //   .InsertOrUpdateJobSchedule(this.JobScheduleViewModel)
    //   .subscribe(
    //     (responsedata: { body: any; }) => {
    //       if (responsedata.body != null) {
    //         this.jobScheduleId = responsedata.body as any;
    //         this.GetJobScheduleDataByScheduleId(this.jobScheduleId);
    //         // this.router.navigate([`Wizard/${this.jobScheduleId}`]);
    //         window.history.replaceState(
    //           null,
    //           null,
    //           '/Wizard/' + this.jobScheduleId
    //         );
    //         this.router.navigate(['/Scheduler']);
    //       }
    //     },
    //     (error: any) => {
    //       // console.log('Error: ', error);
    //     }
    //   );
  }

  CancelClick(): void {
    if (
      confirm(
        'Any changes done to the jobschedule would be lost. Do you want to continue?'
      )
    ) {
      this.router.navigate(['/Scheduler']);
    }
  }

  OnToggleButtonClick(): void {
    if (this.toggleButtonText.toLocaleLowerCase() === 'add new phase') {
      this.toggleButtonText = 'Show Selected Phases';
      this.showSelectedPhaseGrid = false;
      this.getAllContractItemsByCompanyIdAndContractId(
        this.selectedCompanyID,
        this.SelectedJobID
      );
    } else {
      this.toggleButtonText = 'Add New Phase';
      this.showSelectedPhaseGrid = true;
    }
  }

  GetSelectedEmployeeName(selectedEmployeeData: any): any {
    const sortName: any = !isNOU(this.selectedEmployeeData.sortName)
      ? this.selectedEmployeeData.sortName
      : '';
    const position: any = !isNOU(this.selectedEmployeeData.positionCode)
      ? '-' + this.selectedEmployeeData.positionCode
      : '';

    return sortName + position;
  }

  GetSelectedEmployeeFullName(selectedEmployeeData: any): any {
    const fullName: any = !isNOU(this.selectedEmployeeData.fullName)
      ? this.selectedEmployeeData.fullName
      : '';

    const position: any = !isNOU(this.selectedEmployeeData.positionCode)
      ? '-' + this.selectedEmployeeData.positionCode
      : '';

    return fullName + position;
  }

  rowSelected(
    args: any,
    item: ActivePhase,
    gridComponent: GridComponent
  ): void {
    let empName: any;
    let empFullName: any;
    this.selectedEmployeeData = args.data;
    const phaseId = args.row.getElementsByClassName('tempPhaseId')[0].innerText;
    if (args.target.id === 'btnDeSelectEmployee') {
      empName = this.GetSelectedEmployeeName(this.selectedEmployeeData);

      this.arrayOfEmployeeNames = item.employees
        ? item.employees.split('; ')
        : [];
      for (let i = 0; i < this.arrayOfEmployeeNames.length; i++) {
        this.arrayOfEmployeeNames[i] = this.arrayOfEmployeeNames[i].replace(
          /^\s\s*/,
          ''
        );
      }
      this.arrayOfEmployeeNames.splice(
        this.arrayOfEmployeeNames.indexOf(empName),
        1
      );
      item.employees = this.arrayOfEmployeeNames.join('; ');
      this.arrayOfEmployeeNames = item.employees.split('; ');

      empFullName = this.GetSelectedEmployeeFullName(this.selectedEmployeeData);
      this.arrayOfEmployeeFullNames = item.employeesFullName
        ? item.employeesFullName.split('; ')
        : [];
      for (let i = 0; i < this.arrayOfEmployeeFullNames.length; i++) {
        this.arrayOfEmployeeFullNames[i] = this.arrayOfEmployeeFullNames[
          i
        ].replace(/^\s\s*/, '');
      }
      this.arrayOfEmployeeFullNames.splice(
        this.arrayOfEmployeeFullNames.indexOf(empFullName),
        1
      );

      item.employeesFullName = this.arrayOfEmployeeFullNames.join('; ');

      this.arrayOfEmployeeFullNames = item.employeesFullName.split('; ');

      for (const iterator of this.selectedJobs.ActivePhase) {
        if (
          iterator.phaseId.replace(/\s/g, '').trim() ===
          phaseId.replace(/\s/g, '').trim()
        ) {
          const index = iterator.workForce.findIndex(
            (x: { employeeId: any }) =>
              x.employeeId === this.selectedEmployeeData.employeeId
          );
          if (index > -1) {
            iterator.workForce[index].isAdded = false;
            iterator.workForce[index].isDeleted = false;
          }
        }
      }

      const index = item.workForce.findIndex(
        (x: { employeeId: any; phaseId: string }) =>
          x.employeeId === this.selectedEmployeeData.employeeId &&
          x.phaseId.replace(/\s/g, '').trim() ===
            phaseId.replace(/\s/g, '').trim()
      );
      if (index > -1) {
        item.workForce[index].isDeleted = true;
      }
      gridComponent.refresh();

      if (!isNOU(this.selectedEmployeeData)) {
        this.JobSchedulePhaseWorkForceVM =
          new JobSchedulePhaseWorkForceViewModel();
        this.JobSchedulePhaseWorkForceVM.jobScheduleId =
          this.selectedEmployeeData.jobScheduleId;
        this.JobSchedulePhaseWorkForceVM.employeeId =
          this.selectedEmployeeData.employeeId;
        this.JobSchedulePhaseWorkForceVM.isDeleted = false;
        this.JobSchedulePhaseWorkForceVM.worksFor =
          this.selectedEmployeeData.companyId;
        for (const iterator of this.JobScheduleViewModel
          .jobSchedulePhaseViewModelList) {
          if (isNOU(iterator.jobSchedulePhaseWorkForceViewModelList)) {
            iterator.jobSchedulePhaseWorkForceViewModelList = [];
          }
          if (
            iterator.phaseId.replace(/\s/g, '').trim() ===
            phaseId.replace(/\s/g, '').trim()
          ) {
            const index =
              iterator.jobSchedulePhaseWorkForceViewModelList.findIndex(
                (w) => w.employeeId === this.selectedEmployeeData.employeeId
              );
            if (index > -1) {
              iterator.jobSchedulePhaseWorkForceViewModelList[index].isDeleted =
                true;
            }
          }
        }
      }
    } else if (args.target.id === 'btnSelectEmployee') {
      empName = this.GetSelectedEmployeeName(this.selectedEmployeeData);

      // item.employees = empName;
      this.arrayOfEmployeeNames.push(empName);
      if (!isNOU(item.employees) && item.employees !== '') {
        item.employees = item.employees + empName + '; ';
      } else {
        item.employees = empName + '; ';
      }

      empFullName = this.GetSelectedEmployeeFullName(this.selectedEmployeeData);

      // item.employees = empName;
      this.arrayOfEmployeeFullNames.push(empName);
      if (!isNOU(item.employeesFullName) && item.employeesFullName !== '') {
        item.employeesFullName = item.employeesFullName + empFullName + '; ';
      } else {
        item.employeesFullName = empFullName + '; ';
      }

      for (const iterator of this.selectedJobs.ActivePhase) {
        if (
          iterator.phaseId.replace(/\s/g, '').trim() ===
          phaseId.replace(/\s/g, '').trim()
        ) {
          const index = iterator.workForce.findIndex(
            (x: { employeeId: any }) =>
              x.employeeId === this.selectedEmployeeData.employeeId
          );
          iterator.workForce[index].isAdded = true;
        }
      }

      const index = item.workForce.findIndex(
        (x: { employeeId: any; phaseId: string }) =>
          x.employeeId === this.selectedEmployeeData.employeeId &&
          x.phaseId.replace(/\s/g, '').trim() ===
            phaseId.replace(/\s/g, '').trim()
      );
      item.workForce[index].isAdded = true;

      gridComponent.refresh();

      if (
        item.phaseId.replace(/\s/g, '').trim() ===
        phaseId.replace(/\s/g, '').trim()
      ) {
        const index = item.workForce.findIndex(
          (x: { employeeId: any }) =>
            x.employeeId === this.selectedEmployeeData.employeeId
        );
        if (index > -1) {
          item.workForce[index].isAdded = true;
        }

        if (!isNOU(this.selectedEmployeeData)) {
          this.JobSchedulePhaseWorkForceVM =
            new JobSchedulePhaseWorkForceViewModel();
          this.JobSchedulePhaseWorkForceVM.jobScheduleId =
            this.selectedEmployeeData.jobScheduleId;
          this.JobSchedulePhaseWorkForceVM.employeeId =
            this.selectedEmployeeData.employeeId;
          this.JobSchedulePhaseWorkForceVM.isDeleted = false;
          this.JobSchedulePhaseWorkForceVM.worksFor =
            this.selectedEmployeeData.companyId;
          for (const iterator of this.JobScheduleViewModel
            .jobSchedulePhaseViewModelList) {
            if (isNOU(iterator.jobSchedulePhaseWorkForceViewModelList)) {
              iterator.jobSchedulePhaseWorkForceViewModelList = [];
            }
            if (
              iterator.phaseId.replace(/\s/g, '').trim() ===
              phaseId.replace(/\s/g, '').trim()
            ) {
              iterator.jobSchedulePhaseWorkForceViewModelList.push(
                this.JobSchedulePhaseWorkForceVM
              );
            }
          }
        }
      }
    }
  }

  SubmitJobSchedule(): any {
    this.spinner.show();
    let reqObj = {
      jobScheduleId: this.JobScheduleViewModel.jobScheduleId,
      Notes: this.JobScheduleViewModel.notes,
    };
    return this.wizardService.SubmitJobSchedule(reqObj).subscribe(
      () => {
        this.spinner.hide();
        Swal.fire({
          title: 'Schedule Job',
          text: 'Job created successfully !',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'Ok',
        }).then((result: { isConfirmed: any; }) => {
          if (result.isConfirmed) {
            this.spinner.hide();
            this.router.navigate(['/Scheduler']);
          }
        });
      },
      () => {
        // console.log('Error: ', error);
        this.spinner.hide();
      }
    );
  }

  Close(): void {
    this.router.navigate(['/Scheduler']);
  }

  tooltip(args: QueryCellInfoEventArgs): any {}

  GetCurrentUser(): any {
    this.userService.GetCurrentUser().subscribe(
      (responsesData: { body: { companyId: number } }) => {
        this.currentUser = responsesData.body;
        this.selectedJobs.companyId = responsesData.body.companyId;
        this.selectedCompanyID = responsesData.body.companyId;
        const startDate = this.datePipe.transform(
          this.selectedJobs.startDate,
          'MM/dd/yyyy'
        ) as any;
      },
      () => {}
    );
  }

  SaveAndClose(action: any): void {
    this.action = action;
    if (this.step1) {
      this.showNextStep(action);
    } else {
      this.spinner.show();
      this.InsertStepTwo();
    }
  }

  public select(args: MenuEventArgs): void {
    if (args.item.text === 'Copy Job') {
      this.CopyJobSchedule();
    } else if (args.item.text === 'Delete Job') {
      const message = 'Are you sure you want to delete the job?';
      Swal.fire({
        title: 'Job Action',
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result: { isConfirmed: any; }) => {
        if (result.isConfirmed) {
          this.DeleteJob();
        }
      });
    }
  }

  // public onJobDataFiltering: EmitType<any> = (e: FilteringEventArgs) => {
  //   let query = new Query();
  //   // frame the query based on search string with filter type.
  //   query =
  //     // tslint:disable-next-line: triple-equals
  //     (e.text != '')
  //       ? query.where('contractIdDescription', 'contains', e.text, true)
  //       : query;
  //   // pass the filter data source, filter query to updateData method.
  //   e.updateData(this.jobData, query);
  // };

  public onJobDataFiltering(e: FilteringEventArgs): void {
    if (e.text) {
      this.jobData = [...this._jobData].filter(job => job.contractIdDescription?.toString().toLowerCase().includes(e.text.toLowerCase()));
    } else {
      this.jobData = [...this._jobData];
    }
  };

  public onItemFiltering(e: FilteringEventArgs): void {
    if (e.text) {
      this.itemDataSource = [...this._itemDataSource].filter(item => item.itemDescription?.toString().toLowerCase().includes(e.text.toLowerCase()));
    } else {
      this.itemDataSource = [...this._itemDataSource];
    }
  };


  // public onItemFiltering: EmitType<any> = (e: FilteringEventArgs) => {
  //   let query = new Query();
  //   // frame the query based on search string with filter type.
  //   query =
  //     // tslint:disable-next-line: triple-equals
  //     e.text != ''
  //       ? query.where('itemDescription', 'contains', e.text, true)
  //       : query;
  //   // pass the filter data source, filter query to updateData method.
  //   e.updateData(this.itemDataSource, query);
  // };

  CopyJobSchedule(): void {
    this.wizardService.CopyJobSchedule(this.currentJobScheduleId).subscribe(
      (responsesData: string) => {
        Swal.fire('Copy Job', 'Job copied successfully', 'success');
        setTimeout(() => {
          window.history.replaceState(null, '', '/Wizard/' + responsesData);
          window.location.reload();
        }, 1000);
      },
      () => {
        alert('Something went wrong');
      }
    );
  }

  DeleteJob(): void {
    this.wizardService
      .DeleteJobSchedule(this.JobScheduleViewModel.jobScheduleId)
      .subscribe(
        () => {
          alert('Job was deleted successfully');
          this.router.navigate(['/Scheduler']);
        },
        () => {
          alert('Something went wrong');
        }
      );
  }

  RemoveActivePhase(args: any): any {
    this.selectedPhaseData = this.grid.getRowInfo(args.target);
    for (const activePhaseiterator of this.selectedJobs.ActivePhase) {
      const activephaseList = activePhaseiterator;
      if (
        this.selectedPhaseData.rowData.phaseId.replace(/\s/g, '').trim() ===
        activephaseList.phaseId.replace(/\s/g, '').trim()
      ) {
        activePhaseiterator.isDeleted = false;
        activePhaseiterator.isAdded = false;
        // this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i].isModified = true;
        this.gridDataSource.find(
          (x: { phaseId: any }) => x.phaseId === activePhaseiterator.phaseId
        ).isAddedToJobSchedule = false;
      }
    }

    for (const iterator of this.JobScheduleViewModel
      .jobSchedulePhaseViewModelList) {
      const obj = iterator;

      if (
        this.selectedPhaseData.rowData.phaseId.replace(/\s/g, '').trim() ===
        obj.phaseId.replace(/\s/g, '').trim()
      ) {
        iterator.isDeleted = false;
        iterator.isModified = true;
      }
    }
    this.selectedPhaseData = this.grid.getRowInfo(args.target);

    for (let i = 0; i < this.selectedJobs.ActivePhase.length; i++) {
      const obj = this.selectedJobs.ActivePhase[i];
      if (
        this.selectedPhaseData.rowData.phaseId.replace(/\s/g, '').trim() ===
        obj.phaseId.replace(/\s/g, '').trim()
      ) {
        this.selectedPhaseData.isAdded = false;
        this.selectedPhaseData.isDeleted = true;
        this.selectedJobs.ActivePhase.splice(i, 1);
      }
    }
    // tslint:disable-next-line: prefer-for-of
    for (
      let i = 0;
      i < this.JobScheduleViewModel.jobSchedulePhaseViewModelList.length;
      i++
    ) {
      const obj = this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i];
      if (
        this.selectedPhaseData.rowData.phaseId.replace(/\s/g, '').trim() ===
        obj.phaseId.replace(/\s/g, '').trim()
      ) {
        this.JobScheduleViewModel.jobSchedulePhaseViewModelList[i].isDeleted =
          true;
        this.jobSchedulePhaseViewModel.isModified = true;
      }
    }
    this.grid.refresh();
  }

  public sortComparer = (reference: string, comparer: string) => {
    const referenceText = reference.split(' ');
    const finalText = [];
    finalText[0] = referenceText[0];
    finalText[1] = referenceText[1];
    finalText[2] = referenceText[4];
    finalText[3] = referenceText[2];
    finalText[4] = referenceText[3];

    const referenceObj = finalText.toString().replace(',', ' ');
    const comparerText = comparer.split(' ');
    const finalComparerText = [];
    finalComparerText[0] = comparerText[0];
    finalComparerText[1] = comparerText[1];
    finalComparerText[2] = comparerText[4];
    finalComparerText[3] = comparerText[2];
    finalComparerText[4] = comparerText[3];
    const comparerObj = finalComparerText.toString().replace(',', ' ');
    if (comparerObj < referenceObj) {
      return -1;
    }
    if (comparerObj > referenceObj) {
      return 1;
    }
    return 0;
  };
}
